import { useState } from 'react';
import { BiLike } from 'react-icons/bi';

import { useAuthContext } from '../hooks/useAuthContext';
import { useQuery, useMutation } from "@apollo/client";
import { GET_LIKES } from '../queries/likesQueries';
import { ADD_LIKE } from '../mutations/likeMutations';
import { GET_POST } from "../queries/postQueries";
import Spinner from './Spinner';

export default function AddLikeButton({ postId }) {
  const [likes, setLikes] = useState()
  const { data } = useQuery(GET_POST, { variables: { id: postId } })
  const { data: likesData, loading, refetch } = useQuery(GET_LIKES, {
    variables: { postId },
    onCompleted(data) {
      setLikes(data.likes)
    },
    onError: (error) => {
      throw new Error(error.message)
    }
  })

  const { authUser } = useAuthContext()

  const [addLike] = useMutation(ADD_LIKE, {
    variables: { postId, userId: authUser.id },
    refetchQueries: [{ query: GET_POST, variables: { id: postId } }],
    onCompleted() {
      refetch()
    },
    onError: (error) => {
      throw new Error(error.message)
    }
  })

  //if (loading) return <Spinner />

  return (
    <button
      type='button'
      className='btn btn-sm btn-rose me-2'
      onClick={() => addLike({ variables: { postId, userId: authUser.id } })}
    >
      <div className='d-flex rfs-4'>
        {data && likesData && likes?.length > 0 && (
          <div className='me-1'>
            {likes.length}
          </div>
        )}

        <div>
          <BiLike className='icon' />
        </div>
      </div>
    </button>
  )
}
